import EntitiesListStatusContainer from './entities_list_status_container';

const EntitiesListStatus = EntitiesListStatusContainer;

export default EntitiesListStatus;
